export const toQueryString = (obj, prefix) => {
    const str = []
    for (const p in obj) {
        if (obj.hasOwnProperty(p)) {
            const k = prefix ? `${prefix}[${p}]` : p, v = obj[p]
            str.push((v !== null && typeof v === "object") ?
                toQueryString(v, k) :
                `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        }
    }
    return str.join("&")
}